/**
 * 处理视频通话系统通知 VIDEO_CALL_MSG_NOTICE
 *
 * 职责：
 * 1. 接收 IM 推送的视频通话系统通知消息
 * 2. 添加到 videoCallStore 的消息列表中
 * 3. 支持合规警告和用户引导等系统消息
 */

import { useVideoCallStore } from '@/stores/videoCall'
import { VIDEO_MSG_TYPES } from '@/common/constants/videoMsgTypes'

/**
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export function handleVideoCallSystemNotice(event) {
  console.log('[handleVideoCallSystemNotice] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  const videoCallStore = useVideoCallStore()
  const currentRoomInfo = videoCallStore.currentRoomInfo

  if (!currentRoomInfo) {
    return
  }

  videoCallStore.addMessages(
    messages
      .filter(({ msg_content }) => {
        // 只处理当前直播间的消息
        return msg_content.live_id === currentRoomInfo.live_id
      })
      .map(({ msg_content, client_id, timestamp }, index) => {
        return {
          ...msg_content,
          id: `${client_id}-${timestamp}-${index}`,
          type: VIDEO_MSG_TYPES.SYSTEM,
        }
      })
  )
}
